__webpack_require__.p = "/Bank-of-React/";